import { MuiChartType } from '@verantos-dev/shared-components';
import { CohortCharacteristicsResultType } from '@verantos-dev/types-cohorts';

export const cohortCharacteristicResultTypeToTabularSectionNameMap = {
  [CohortCharacteristicsResultType.AGE_AT_INDEX]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ageAtIndexSection',
  [CohortCharacteristicsResultType.ETHNICITY]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ethnicitySection',
  [CohortCharacteristicsResultType.GENDER]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.genderSection',
  [CohortCharacteristicsResultType.RACE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.raceSection',
};

export const cohortCharacteristicResultTypeToSectionNameMap = {
  [CohortCharacteristicsResultType.AGE_AT_INDEX]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ageAtIndex',
  [CohortCharacteristicsResultType.ETHNICITY]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ethnicity',
  [CohortCharacteristicsResultType.GENDER]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.gender',
  [CohortCharacteristicsResultType.RACE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.section.race',
};

export const cohortCharacteristicResultTypeToDefaultChartTypeMap = {
  [CohortCharacteristicsResultType.AGE_AT_INDEX]: MuiChartType.BAR,
  [CohortCharacteristicsResultType.ETHNICITY]: MuiChartType.DONUT,
  [CohortCharacteristicsResultType.GENDER]: MuiChartType.DONUT,
  [CohortCharacteristicsResultType.RACE]: MuiChartType.DONUT,
};

export const cohortCharacteristicResultTitleEmptyMap = {
  [CohortCharacteristicsResultType.AGE_AT_INDEX]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ageAtIndex',
  [CohortCharacteristicsResultType.ETHNICITY]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ethnicity',
  [CohortCharacteristicsResultType.GENDER]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.gender',
  [CohortCharacteristicsResultType.RACE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.race',
};

export const cohortCharacteristicResultMessageeEmptyMap = {
  [CohortCharacteristicsResultType.AGE_AT_INDEX]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ageAtIndex',
  [CohortCharacteristicsResultType.ETHNICITY]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ethnicity',
  [CohortCharacteristicsResultType.GENDER]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.messge.empty.gender',
  [CohortCharacteristicsResultType.RACE]:
    'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.race',
};
